import axios from "axios";
import qs from "qs";
import Vue from "vue";

export default {

    get(url,header){
        return new Promise((resolve,reject)=>{
            axios.get(url,{
                headers: header
            }).then((res)=>{
                resolve(res.data);
            }).catch(e=>{
                reject(e);
            })
        });
    },
    //post by x-www-form-urlencoded
    post(url,params,header){
        if (!header){
            header = {}
        }
        header["Content-Type"] = "application/x-www-form-urlencoded";
        let query = qs.stringify(params);
        console.log("q",query);
        return new Promise((resolve,reject)=>{
            axios.post(url,query,{
                headers: header
            }).then((res)=>{
                resolve(res.data);
            }).catch(e=>{
                reject(e);
            })
        });
    },
    //post by multipart/form-data
    postFormData(url,formData,header){
        if (!header){
            header = {};
        }
        header["Content-Type"] = "multipart/form-data";
        return new Promise((resolve,reject)=>{
            axios.post(url,formData,{
                headers: header
            }).then((res)=>{
                resolve(res.data);
            }).catch(e=>{
                reject(e);
            })
        });
    },
    postJson(url,jsonString,header){
        if (!header){
            header = {};
        }
        header["Content-Type"] = "application/json";
        return new Promise((resolve,reject)=>{
            axios.post(url,jsonString,{
                headers: header
            }).then((res)=>{
                resolve(res.data);
            }).catch(e=>{
                reject(e);
            })
        });
    }
}